// extracted by mini-css-extract-plugin
export var bodySections = "_5b-8";
export var gray = "_5b-7";
export var green = "_5b-4";
export var iconContainer = "_5b-9";
export var iconWidgetContainer = "_5b-1";
export var phoneIcon = "_5b-2";
export var red = "_5b-5";
export var statusDot = "_5b-3";
export var widgetContainer = "_5b-0";
export var yellow = "_5b-6";